import { Breadcrumbs } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Colors from '../../../layout/theme/utils/colors';

const styles = () => ({
  separator: {
    color: Colors.white,
  },
});

export const StyledBreadcrumb = withStyles(styles)(Breadcrumbs);
